import { useEffect, useState } from 'react'
import { addAgent } from '../components/access_management/AddAgent'
import { buildRegisteredAgentData } from '../components/chat/utils/agentRegistrationHelpers'

const useAgentRegistration = ({
  isExistingUser,
  agentData,
  environment,
  isTrial,
  dispatch,
  setAgentData,
  getAnswersMap,
}) => {
  const [hasRegistered, setHasRegistered] = useState(false)

  const requestRegistration = () => {
    setHasRegistered(true)
  }

  useEffect(() => {
    if (!isExistingUser && hasRegistered) {
      const answersMap = getAnswersMap()

      const updatedAgentData = buildRegisteredAgentData({
        agentData,
        answersMap,
      })

      dispatch(setAgentData(updatedAgentData))

      addAgent(updatedAgentData, environment, isTrial, dispatch).catch(
        (error) => {
          console.error('Error registering new user:', error)
        },
      )

      setHasRegistered(false)
    }
  }, [
    isExistingUser,
    hasRegistered,
    agentData,
    environment,
    isTrial,
    dispatch,
    setAgentData,
    getAnswersMap,
  ])

  return {
    requestRegistration,
  }
}

export default useAgentRegistration